export const siteConfig = {
  brandName: "pirecobalt",
  legalName: "Pirecobalt Limited",
  description:
    "Thoughtful paper goods, designed to make the everyday feel noteworthy.",
  country: {
    code: "DE",
    name: "Germany",
  },
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  contact: {
    email: "feedback@pirecobalt.store",
    hours: "Monday–Friday, 9am–6pm CET/CEST",
    address: "Rebbergweg 1B, 79761 Waldshut-Tiengen-Gurtweil, De",
  },
  shipping: {
    standard: 9.99,
    express: 19.99,
  },
  promotions: [
    "FLAT-RATE DELIVERY $9.99",
    "ORIGINAL PAPER GOODS FOR EVERYDAY PLANS",
    "PERSONALISE IT, MAKE IT YOURS",
  ],
  navigation: [
    { label: "Diaries & Planners", category: "Planners" },
    { label: "Notebooks", category: "Notebooks" },
    { label: "Journals", category: "Journals" },
    { label: "Photo", category: "Photo Books" },
    { label: "Stationery", category: "Accessories" },
    { label: "Cards & Hosting", category: "Cards" },
    { label: "Gifts", tag: "gift" },
  ],
};

const products = [
  {
    id: 1,
    name: "Morning Meadow",
    category: "Planners",
    productType: "Undated Daily Planner",
    price: 30,
    originalPrice: null,
    badge: "Studio pick",
    image: "/img/products/morning-meadow-main.webp",
    images: [
      "/img/products/morning-meadow-main.webp",
      "/img/products/morning-meadow-detail.webp",
    ],
    description:
      "A calm, flexible planner for turning busy days into considered routines, with space for priorities, notes and small wins.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Casebound hardback",
      Pages: "192 undated pages",
      Paper: "100gsm smooth ivory paper",
    },
    options: {
      Colour: ["Fern", "Rose", "Sky"],
      Format: ["Daily", "Weekly"],
    },
    tags: ["planner", "personalised", "gift", "bestseller"],
    rating: 4.9,
    reviews: 186,
    featured: true,
  },
  {
    id: 2,
    name: "Sunroom Stripe",
    category: "Notebooks",
    productType: "Hardback Lined Notebook",
    price: 23,
    originalPrice: null,
    badge: "Bestseller",
    image: "/img/products/sunroom-stripe-main.webp",
    images: [
      "/img/products/sunroom-stripe-main.webp",
      "/img/products/sunroom-stripe-detail.webp",
    ],
    description:
      "Warm stripes wrap this desk-ready notebook, finished with a ribbon marker and pages made for lists, ideas and everything between.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Casebound hardback",
      Pages: "176 lined pages",
      Paper: "90gsm off-white paper",
    },
    options: {
      Colour: ["Apricot", "Olive", "Cobalt"],
      Format: ["Lined", "Plain", "Dotted"],
    },
    tags: ["notebook", "personalised", "bestseller"],
    rating: 4.8,
    reviews: 142,
    featured: true,
  },
  {
    id: 3,
    name: "Little Chapters",
    category: "Photo Books",
    productType: "Mini Hardback Photo Book",
    price: 28,
    originalPrice: null,
    badge: "New",
    image: "/img/products/little-chapters-main.webp",
    images: [
      "/img/products/little-chapters-main.webp",
      "/img/products/little-chapters-detail.webp",
    ],
    description:
      "A compact keepsake for the everyday photographs that tell your favourite stories, printed on weighty, softly textured paper.",
    attributes: {
      Size: "16.5 × 16.5cm",
      Binding: "Hardback",
      Pages: "24–80 pages",
      Paper: "200gsm satin photo paper",
    },
    options: {
      Colour: ["Butter", "Blush", "Ink"],
      Format: ["24 pages", "40 pages", "80 pages"],
    },
    tags: ["photo", "gift", "personalised", "new"],
    rating: 4.8,
    reviews: 92,
    featured: true,
  },
  {
    id: 4,
    name: "Gathered Blooms",
    category: "Journals",
    productType: "Gratitude Journal",
    price: 26,
    originalPrice: null,
    badge: null,
    image: "/img/products/gathered-blooms-main.webp",
    images: [
      "/img/products/gathered-blooms-main.webp",
      "/img/products/gathered-blooms-detail.webp",
    ],
    description:
      "Gentle prompts and open pages create a five-minute ritual for noticing what feels good, meaningful and worth remembering.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Cloth hardback",
      Pages: "192 guided pages",
      Paper: "100gsm ivory paper",
    },
    options: {
      Colour: ["Rosewood", "Sage"],
      Format: ["Gratitude", "Wellness"],
    },
    tags: ["journal", "wellness", "gift"],
    rating: 4.9,
    reviews: 121,
    featured: true,
  },
  {
    id: 5,
    name: "Tide & Time",
    category: "Planners",
    productType: "Academic Year Diary",
    price: 25,
    originalPrice: 30,
    badge: "20% off",
    image: "/img/products/tide-and-time-main.webp",
    images: [
      "/img/products/tide-and-time-main.webp",
      "/img/products/tide-and-time-detail.webp",
    ],
    description:
      "A week-to-view academic diary with monthly overviews, timetable pages and a quietly graphic wave cover.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Casebound hardback",
      Pages: "224 dated pages",
      Paper: "90gsm responsibly sourced paper",
    },
    options: {
      Colour: ["Marine", "Poppy"],
      Format: ["Hardback", "Spiral"],
    },
    tags: ["planner", "academic", "personalised", "sale"],
    rating: 4.7,
    reviews: 78,
    featured: true,
  },
  {
    id: 6,
    name: "Pear Orchard",
    category: "Notebooks",
    productType: "Softback Spiral Notebook",
    price: 22,
    originalPrice: null,
    badge: null,
    image: "/img/products/pear-orchard-main.webp",
    images: [
      "/img/products/pear-orchard-main.webp",
      "/img/products/pear-orchard-detail.webp",
    ],
    description:
      "A cheerful spiral notebook with a lay-flat format, roomy pages and painterly pears scattered across a butter-yellow cover.",
    attributes: {
      Size: "B5 · 19 × 25cm",
      Binding: "Bronze wire spiral",
      Pages: "160 lined pages",
      Paper: "90gsm smooth paper",
    },
    options: {
      Colour: ["Butter", "Leaf"],
      Format: ["Lined", "Dotted"],
    },
    tags: ["notebook", "spiral", "gift"],
    rating: 4.7,
    reviews: 64,
    featured: false,
  },
  {
    id: 7,
    name: "Recipe Archive",
    category: "Journals",
    productType: "Recipe Journal",
    price: 29,
    originalPrice: null,
    badge: "Gift favourite",
    image: "/img/products/recipe-archive-main.webp",
    images: [
      "/img/products/recipe-archive-main.webp",
      "/img/products/recipe-archive-detail.webp",
    ],
    description:
      "Keep treasured recipes, clever substitutions and family favourites together in a wipe-clean, tabbed kitchen companion.",
    attributes: {
      Size: "20 × 25cm",
      Binding: "Concealed spiral",
      Pages: "144 guided pages",
      Paper: "120gsm writing paper",
    },
    options: {
      Colour: ["Tomato", "Cream"],
      Format: ["Hardback", "Spiral"],
    },
    tags: ["journal", "recipe", "gift"],
    rating: 4.9,
    reviews: 203,
    featured: true,
  },
  {
    id: 8,
    name: "Postcard Summer",
    category: "Cards",
    productType: "Notecard Set",
    price: 24,
    originalPrice: null,
    badge: null,
    image: "/img/products/postcard-summer-main.webp",
    images: [
      "/img/products/postcard-summer-main.webp",
      "/img/products/postcard-summer-detail.webp",
    ],
    description:
      "Twelve illustrated notecards and matching envelopes for thank-yous, thinking-of-yous and notes sent simply because.",
    attributes: {
      Size: "A6 folded cards",
      Quantity: "12 cards and envelopes",
      Finish: "Uncoated matte",
      Paper: "350gsm card stock",
    },
    options: {
      Colour: ["Mixed brights", "Soft neutrals"],
      Format: ["Set of 12", "Set of 24"],
    },
    tags: ["cards", "stationery", "gift"],
    rating: 4.8,
    reviews: 56,
    featured: false,
  },
  {
    id: 9,
    name: "Blue Hour",
    category: "Photo Books",
    productType: "Large Hardback Photo Book",
    price: 48,
    originalPrice: 60,
    badge: "20% off",
    image: "/img/products/blue-hour-main.webp",
    images: [
      "/img/products/blue-hour-main.webp",
      "/img/products/blue-hour-detail.webp",
    ],
    description:
      "An elegant landscape photo book with a deep-blue cloth spine and generous layouts for travels, celebrations and ordinary magic.",
    attributes: {
      Size: "28.5 × 22cm",
      Binding: "Hardback with cloth spine",
      Pages: "24–100 pages",
      Paper: "200gsm satin photo paper",
    },
    options: {
      Colour: ["Midnight", "Oat", "Terracotta"],
      Format: ["24 pages", "40 pages", "80 pages"],
    },
    tags: ["photo", "gift", "personalised", "sale"],
    rating: 4.9,
    reviews: 174,
    featured: true,
  },
  {
    id: 10,
    name: "Quiet Geometry",
    category: "Notebooks",
    productType: "Hardback Bullet Journal",
    price: 24,
    originalPrice: null,
    badge: "New",
    image: "/img/products/quiet-geometry-main.webp",
    images: [
      "/img/products/quiet-geometry-main.webp",
      "/img/products/quiet-geometry-detail.webp",
    ],
    description:
      "A precise dot-grid notebook in an understated geometric cover, designed for trackers, sketches and plans shaped your way.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Casebound hardback",
      Pages: "192 dot-grid pages",
      Paper: "120gsm bright white paper",
    },
    options: {
      Colour: ["Moss", "Clay", "Lilac"],
      Format: ["Dotted", "Plain"],
    },
    tags: ["notebook", "bullet journal", "personalised", "new"],
    rating: 4.8,
    reviews: 39,
    featured: false,
  },
  {
    id: 11,
    name: "Golden Margin",
    category: "Planners",
    productType: "Productivity Planner",
    price: 27,
    originalPrice: null,
    badge: null,
    image: "/img/products/golden-margin-main.webp",
    images: [
      "/img/products/golden-margin-main.webp",
      "/img/products/golden-margin-detail.webp",
    ],
    description:
      "Sixteen focused weeks of goals, time blocking and reflections, bound in a sunlit cover with subtle gold-foil details.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Hardback",
      Pages: "224 guided pages",
      Paper: "100gsm ivory paper",
    },
    options: {
      Colour: ["Ochre", "Navy"],
      Format: ["Daily", "Weekly"],
    },
    tags: ["planner", "productivity", "personalised"],
    rating: 4.7,
    reviews: 88,
    featured: false,
  },
  {
    id: 12,
    name: "Garden Correspondence",
    category: "Cards",
    productType: "Writing Paper Set",
    price: 30,
    originalPrice: null,
    badge: null,
    image: "/img/products/garden-correspondence-main.webp",
    images: [
      "/img/products/garden-correspondence-main.webp",
      "/img/products/garden-correspondence-detail.webp",
    ],
    description:
      "A personalised writing set edged with loose botanical lines, paired with softly coloured envelopes for beautiful long-form notes.",
    attributes: {
      Size: "A5 writing sheets",
      Quantity: "20 sheets and 10 envelopes",
      Finish: "Personalised header",
      Paper: "120gsm laid paper",
    },
    options: {
      Colour: ["Cornflower", "Rose"],
      Format: ["Set of 20", "Set of 40"],
    },
    tags: ["cards", "letter writing", "personalised", "gift"],
    rating: 4.9,
    reviews: 71,
    featured: false,
  },
  {
    id: 13,
    name: "Wildwood Notes",
    category: "Notebooks",
    productType: "A4 Spiral Notebook",
    price: 28,
    originalPrice: null,
    badge: null,
    image: "/img/products/wildwood-notes-main.webp",
    images: [
      "/img/products/wildwood-notes-main.webp",
      "/img/products/wildwood-notes-detail.webp",
    ],
    description:
      "A generous notebook for sprawling ideas, project notes and studio sketches, with a botanical cover and sturdy bronze wire.",
    attributes: {
      Size: "A4 · 21 × 29.7cm",
      Binding: "Bronze wire spiral",
      Pages: "160 lined pages",
      Paper: "100gsm off-white paper",
    },
    options: {
      Colour: ["Forest", "Rust"],
      Format: ["Lined", "Plain"],
    },
    tags: ["notebook", "spiral", "personalised"],
    rating: 4.6,
    reviews: 47,
    featured: false,
  },
  {
    id: 14,
    name: "Keepsake Year",
    category: "Photo Books",
    productType: "Medium Fabric Photo Book",
    price: 64,
    originalPrice: null,
    badge: "Premium",
    image: "/img/products/keepsake-year-main.webp",
    images: [
      "/img/products/keepsake-year-main.webp",
      "/img/products/keepsake-year-detail.webp",
    ],
    description:
      "A tactile linen-bound album made to gather one whole year of faces, places and tiny moments into a lasting object.",
    attributes: {
      Size: "22 × 22cm",
      Binding: "Foil-stamped linen",
      Pages: "24–100 pages",
      Paper: "200gsm satin photo paper",
    },
    options: {
      Colour: ["Flax", "Rosewood", "Sage"],
      Format: ["24 pages", "40 pages", "80 pages"],
    },
    tags: ["photo", "premium", "gift", "personalised"],
    rating: 5,
    reviews: 119,
    featured: true,
  },
  {
    id: 15,
    name: "Five Good Pens",
    category: "Accessories",
    productType: "Fineliner Pen Set",
    price: 14,
    originalPrice: null,
    badge: null,
    image: "/img/products/five-good-pens-main.webp",
    images: [
      "/img/products/five-good-pens-main.webp",
      "/img/products/five-good-pens-detail.webp",
    ],
    description:
      "Five smooth, quick-drying fineliners in considered colours for annotations, lists, illustrations and a brighter-looking desk.",
    attributes: {
      Nib: "0.4mm fibre tip",
      Quantity: "Set of five",
      Ink: "Water-based, quick drying",
      Packaging: "Recyclable card sleeve",
    },
    options: {
      Colour: ["Earth tones", "Brights"],
      Format: ["Set of 5"],
    },
    tags: ["accessories", "pens", "gift"],
    rating: 4.7,
    reviews: 95,
    featured: false,
  },
  {
    id: 16,
    name: "Ribbon & Rule",
    category: "Accessories",
    productType: "Planner Accessory Set",
    price: 18,
    originalPrice: null,
    badge: "New",
    image: "/img/products/ribbon-and-rule-main.webp",
    images: [
      "/img/products/ribbon-and-rule-main.webp",
      "/img/products/ribbon-and-rule-detail.webp",
    ],
    description:
      "A brass ruler, elastic pen loop and two ribbon bookmarks designed to make daily planning feel wonderfully put together.",
    attributes: {
      Contents: "4-piece set",
      Material: "Brass, cotton and elastic",
      Compatibility: "A5 and B5 books",
      Packaging: "Plastic-free gift box",
    },
    options: {
      Colour: ["Brass & Berry", "Brass & Moss"],
      Format: ["A5 set", "B5 set"],
    },
    tags: ["accessories", "planner", "gift", "new"],
    rating: 4.8,
    reviews: 31,
    featured: false,
  },
  {
    id: 17,
    name: "The Reading Room",
    category: "Journals",
    productType: "Reading Journal",
    price: 27,
    originalPrice: null,
    badge: null,
    image: "/img/products/reading-room-main.webp",
    images: [
      "/img/products/reading-room-main.webp",
      "/img/products/reading-room-detail.webp",
    ],
    description:
      "Record beloved lines, thoughtful reviews and a growing reading list in chapters designed for a lifetime of books.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Cloth hardback",
      Pages: "192 guided pages",
      Paper: "100gsm ivory paper",
    },
    options: {
      Colour: ["Merlot", "Teal"],
      Format: ["Hardback"],
    },
    tags: ["journal", "reading", "gift", "personalised"],
    rating: 4.9,
    reviews: 137,
    featured: true,
  },
  {
    id: 18,
    name: "Cloud Atlas",
    category: "Planners",
    productType: "Finance Planner",
    price: 29,
    originalPrice: null,
    badge: null,
    image: "/img/products/cloud-atlas-main.webp",
    images: [
      "/img/products/cloud-atlas-main.webp",
      "/img/products/cloud-atlas-detail.webp",
    ],
    description:
      "Friendly monthly tools for budgets, savings and reflection, wrapped in an optimistic hand-painted sky.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Hardback",
      Pages: "176 guided pages",
      Paper: "100gsm ivory paper",
    },
    options: {
      Colour: ["Sky", "Dusk"],
      Format: ["12 months"],
    },
    tags: ["planner", "finance", "personalised"],
    rating: 4.7,
    reviews: 52,
    featured: false,
  },
  {
    id: 19,
    name: "Tiny Celebrations",
    category: "Cards",
    productType: "Birthday Card Set",
    price: 18,
    originalPrice: null,
    badge: null,
    image: "/img/products/tiny-celebrations-main.webp",
    images: [
      "/img/products/tiny-celebrations-main.webp",
      "/img/products/tiny-celebrations-detail.webp",
    ],
    description:
      "Six joyful birthday cards with colourful envelopes, ready for the people you always want to celebrate properly.",
    attributes: {
      Size: "A6 folded cards",
      Quantity: "6 cards and envelopes",
      Finish: "Mixed foil details",
      Paper: "350gsm card stock",
    },
    options: {
      Colour: ["Mixed brights"],
      Format: ["Set of 6", "Set of 12"],
    },
    tags: ["cards", "birthday", "gift"],
    rating: 4.8,
    reviews: 43,
    featured: false,
  },
  {
    id: 20,
    name: "Soft Focus",
    category: "Photo Books",
    productType: "A5 Softback Photo Book",
    price: 24,
    originalPrice: 30,
    badge: "20% off",
    image: "/img/products/soft-focus-main.webp",
    images: [
      "/img/products/soft-focus-main.webp",
      "/img/products/soft-focus-detail.webp",
    ],
    description:
      "A light, magazine-like photo book for weekends away, camera-roll favourites and thoughtful little gifts.",
    attributes: {
      Size: "A5 · 21 × 15cm",
      Binding: "Softback perfect bound",
      Pages: "32–64 pages",
      Paper: "170gsm matte photo paper",
    },
    options: {
      Colour: ["Rose", "Cobalt", "Oat"],
      Format: ["32 pages", "48 pages", "64 pages"],
    },
    tags: ["photo", "gift", "personalised", "sale"],
    rating: 4.7,
    reviews: 61,
    featured: false,
  },
  {
    id: 21,
    name: "Everyday Pages",
    category: "Notebooks",
    productType: "Leather Notebook",
    price: 42,
    originalPrice: null,
    badge: "Premium",
    image: "/img/products/everyday-pages-main.webp",
    images: [
      "/img/products/everyday-pages-main.webp",
      "/img/products/everyday-pages-detail.webp",
    ],
    description:
      "Supple recycled leather, gilt page edges and a refillable interior make this a notebook to carry for years.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Refillable leather cover",
      Pages: "160 lined pages",
      Paper: "100gsm ivory paper",
    },
    options: {
      Colour: ["Espresso", "Forest", "Oxblood"],
      Format: ["Lined", "Plain"],
    },
    tags: ["notebook", "premium", "gift", "personalised"],
    rating: 4.9,
    reviews: 112,
    featured: true,
  },
  {
    id: 22,
    name: "Pocket Pep Talks",
    category: "Journals",
    productType: "Wellness Journal",
    price: 25,
    originalPrice: null,
    badge: null,
    image: "/img/products/pocket-pep-talks-main.webp",
    images: [
      "/img/products/pocket-pep-talks-main.webp",
      "/img/products/pocket-pep-talks-detail.webp",
    ],
    description:
      "A warm, unfussy journal filled with short prompts for checking in, resetting and speaking to yourself more kindly.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Hardback",
      Pages: "192 guided pages",
      Paper: "100gsm ivory paper",
    },
    options: {
      Colour: ["Apricot", "Lavender"],
      Format: ["Wellness"],
    },
    tags: ["journal", "wellness", "gift"],
    rating: 4.8,
    reviews: 84,
    featured: false,
  },
  {
    id: 23,
    name: "Desk Garden",
    category: "Accessories",
    productType: "Sticky Notes & Tabs Set",
    price: 12,
    originalPrice: null,
    badge: null,
    image: "/img/products/desk-garden-main.webp",
    images: [
      "/img/products/desk-garden-main.webp",
      "/img/products/desk-garden-detail.webp",
    ],
    description:
      "A compact folio of sticky notes, page flags and translucent tabs in garden-inspired shades for colour-coded thinking.",
    attributes: {
      Contents: "7 pads and tab sets",
      Sheets: "280 notes and tabs",
      Material: "FSC-certified paper",
      Packaging: "Reusable card folio",
    },
    options: {
      Colour: ["Garden", "Sunset"],
      Format: ["One size"],
    },
    tags: ["accessories", "sticky notes", "gift"],
    rating: 4.7,
    reviews: 69,
    featured: false,
  },
  {
    id: 24,
    name: "Plan in Colour",
    category: "Planners",
    productType: "Weekly Desk Planner",
    price: 20,
    originalPrice: null,
    badge: "New",
    image: "/img/products/plan-in-colour-main.webp",
    images: [
      "/img/products/plan-in-colour-main.webp",
      "/img/products/plan-in-colour-detail.webp",
    ],
    description:
      "Fifty-two tear-off weekly spreads keep priorities visible and leave enough room for the plans that appear along the way.",
    attributes: {
      Size: "29.7 × 21cm",
      Binding: "Glue-bound desk pad",
      Pages: "52 tear-off sheets",
      Paper: "100gsm uncoated paper",
    },
    options: {
      Colour: ["Colour block", "Neutral"],
      Format: ["Week to view"],
    },
    tags: ["planner", "desk", "new"],
    rating: 4.6,
    reviews: 28,
    featured: false,
  },
  {
    id: 25,
    name: "Harbour Lines",
    category: "Journals",
    productType: "Clothbound Travel Journal",
    price: 78,
    originalPrice: null,
    badge: "New",
    image: "/img/products/harbour-lines-main.png",
    images: [
      "/img/products/harbour-lines-main.png",
      "/img/products/harbour-lines-detail.png",
    ],
    description:
      "A clothbound travel journal with flexible planning spreads, open note pages and a useful rear pocket for tickets and keepsakes. The lay-flat binding, smooth ivory paper and two ribbon markers make it comfortable for daily notes, itineraries and reflections at home or away.",
    attributes: {
      Size: "A5 · 15.2 × 21.5cm",
      Binding: "Clothbound lay-flat hardback",
      Pages: "192 guided and plain pages",
      Paper: "100gsm smooth ivory paper",
    },
    options: {
      Colour: ["Cobalt", "Sand", "Sage"],
      Format: ["Travel journal"],
    },
    tags: ["journal", "travel", "gift", "new"],
    rating: 4.8,
    reviews: 36,
    featured: false,
  },
];

const priceOverrides = [
  65, 58, 72, 62, 68, 56, 75, 52, 118, 64, 70, 82, 76, 148, 45, 49, 69,
  74, 48, 66, 132, 63, 46, 54, 78,
];

const enrichedProducts = products.map((product, index) => ({
  ...product,
  price: priceOverrides[index],
  originalPrice: product.originalPrice
    ? Math.min(180, Math.round(priceOverrides[index] * 1.25))
    : null,
  description:
    product.id === 25
      ? product.description
      : `${product.description} Built for regular use, it combines carefully chosen materials with practical details and a finish that feels considered in the hand. Each piece is checked before packing and arrives ready to use or give.`,
}));

export const categories = [
  {
    name: "Planners",
    eyebrow: "Plans, beautifully made",
    description: "Daily, weekly and academic pages for every kind of rhythm.",
  },
  {
    name: "Notebooks",
    eyebrow: "A home for every thought",
    description: "Lined, plain and dotted books, ready to personalise.",
  },
  {
    name: "Journals",
    eyebrow: "Make space for yourself",
    description: "Guided pages for wellbeing, recipes, reading and more.",
  },
  {
    name: "Photo Books",
    eyebrow: "Stories worth holding",
    description: "Turn camera-roll favourites into forever keepsakes.",
  },
  {
    name: "Cards",
    eyebrow: "Send something meaningful",
    description: "Paper post for big days, small moments and just because.",
  },
  {
    name: "Accessories",
    eyebrow: "The finishing touches",
    description: "Pens, tabs and desk details for brighter everyday plans.",
  },
];

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
  }).format(value);

export default enrichedProducts;
